module.exports = __webpack_public_path__ + "img/lamp.204a0fb7.svg";